// Reliable Rewardful referral capture.
//
// Rewardful only populates `window.Rewardful.referral` (the referral UUID it
// uses for commission attribution) AFTER its script fires the "ready" event.
// Reading it synchronously at checkout time often returns null, so the sale
// never gets attributed and the affiliate (e.g. our OWN partner) isn't paid.
//
// Fix: capture the referral UUID once Rewardful is ready and persist it, then
// read the live value OR the persisted one at checkout. ALWAYS send the UUID
// (not the raw ?via= token) — that's what Stripe's client_reference_id must be
// for Rewardful to match the conversion.

const KEY = "rewardful_referral";

/** Run once at app start: persist the referral UUID as soon as it's known. */
export function initRewardful() {
  if (typeof window === "undefined" || typeof window.rewardful !== "function") return;
  try {
    window.rewardful("ready", () => {
      try {
        const ref = window.Rewardful && window.Rewardful.referral;
        if (ref) localStorage.setItem(KEY, ref);
      } catch {
        /* ignore */
      }
    });
  } catch {
    /* ignore */
  }
}

/**
 * The Rewardful referral UUID to send as `referral` at checkout. Prefers the
 * live value (and persists it), falling back to the one captured on "ready".
 */
export function getRewardfulReferral() {
  try {
    const live =
      (typeof window !== "undefined" && window.Rewardful && window.Rewardful.referral) || null;
    if (live) {
      try { localStorage.setItem(KEY, live); } catch { /* ignore */ }
      return live;
    }
    return (typeof window !== "undefined" && localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
}
